import {SideBar} from './SideBar'

export const BasicLayout = (props: any) => {
  const {children} = props
  return <SideBar>{children}</SideBar>
}
